import React from 'react';
import styled, { css } from 'styled-components';

const shouldForwardProp = prop => !['selectedTab', 'isFirstTab', 'isLastTab'].includes(prop);

const FindPasswordTabStyled = styled.div`
  border-radius: 10px;
  background: var(--GrayScale-0);
  display: flex;
  justify-content: space-between;
  border: 1px solid var(--Primary-200);
`;

const Tab = styled.div.withConfig({ shouldForwardProp })`
  flex: 1;
  text-align: center;
  padding: 10px 0;
  cursor: pointer;

  font-family: Pretendard;
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: 20px;
  color: var(--GrayScale-600);
  border-right: 1px solid var(--Primary-200);
  ${props =>
    props.selectedTab &&
    css`
      background: var(--Primary-50);
      color: var(--Primary-500);
      border-right: 1px solid var(--Primary-200);

      ${props.isFirstTab &&
      css`
        border-radius: 10px 0px 0px 10px;
       
      `}

      ${props.isLastTab &&
      css`
        border-radius: 0px 10px 10px 0px;
        border-right: none;
      `}
    `}
`;

const FindPasswordTab = ({ tablist, selectedTab, setSelectedTab }) => {
  return (
    <FindPasswordTabStyled>
      {tablist.map((tab, index) => (
        <Tab
          key={index}
          selectedTab={selectedTab === index}
          isFirstTab={index === 0}
          isLastTab={index === tablist.length - 1}
          onClick={() => setSelectedTab(index)}>
          {tab}
        </Tab>
      ))}
    </FindPasswordTabStyled>
  );
};

export default FindPasswordTab;
